package com.checkin.host.ui.components

import org.jetbrains.compose.web.attributes.AttrsScope
import org.jetbrains.compose.web.attributes.selected
import org.w3c.dom.HTMLOptionElement

fun AttrsScope<HTMLOptionElement>.markSelected(isSelected: Boolean) {
    if (isSelected) selected()
}
